export default __webpack_public_path__ + "static/media/icon-edit-blue.ffa648e0.svg";